import Box from '@mui/material/Box';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import React, { Fragment, useState, useEffect } from 'react';
import estilos from './ToolBarPaginas.module.css'
function TabLista({ value, handleChange, data }) {

  const [stickyClass, setStickyClass] = useState('');

  useEffect(() => {
    window.addEventListener('scroll', stickNavbar);
    return () => window.removeEventListener('scroll', stickNavbar);
  }, []);

  const stickNavbar = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      windowHeight > 150 ? setStickyClass(estilos.sticky_nav) : setStickyClass('');
    }
  };

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      textAlign: 'center', backgroundColor: '#fcfcfc',
      boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', height: '60px', borderRadius: '8px'
    }} className={`${stickyClass}`}>

      <TabList onChange={handleChange} aria-label="visible arrows tabs example" variant="scrollable" scrollButtons="auto"
        TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }} 
        sx={{
          "& button": { color: '#7D9A47', fontFamily: 'Montserrat', fontWeight: 'bold' },
          "& button:hover": { color: '#7D9A47', transform: 'scale(1.1)' },
          "& button.Mui-selected": { backgroundColor: '#7D9A47', color: 'white', borderTopLeftRadius: 9, borderTopRightRadius: 9, borderBottomLeftRadius: 9, borderBottomRightRadius: 9 }
        }}>

        <Tab label="Datos Generales" value="datosGenerales" />
        <Tab label="Domicilios" value="domicilios" />
        {(data.viverocliente.length > 0 || data.prediocliente.length > 0) &&
          <Tab label={data.viverocliente.length > 0 && data.prediocliente.length > 0 ? 'Viverista/Productor de maguey' :
            data.viverocliente.length > 0 ? 'Viverista' : 'Productor de maguey'} value="viverosPredios" />
        }
        {data.anexocliente.length > 0 &&
          <Tab label="Instalaciones" value="Instalaciones" />
        }
        {(data.marcascliente.length > 0 || data.marcasproductoconmezcalcliente.length > 0) &&
          <Tab label="Marcas" value="marcas" />
        }
        <Tab label="relaciones" value="relaciones" />
        <Tab label="Documentacion" value="documentacion" />

      </TabList>
    </Box>
  );
}

export default TabLista;
